const REQUIRED_MESSAGE = /^.+? is required\b/;

export function shortenFieldMessage(message: string): string {
  return message.replace(REQUIRED_MESSAGE, "Required");
}
